import * as Yup from "yup";
import config from "../../config";
import styled from "styled-components";
import { useFormik } from "formik";
import { ButtonRightCorner, ErrorWrapper, PageContainer } from "../../sharedStyles";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const newCompanySchema = Yup.object().shape({
  companyName: Yup.string().required("company name is required"),
  email: Yup.string().email().required(),
});

const CustomCard = styled.div`
  width: 36rem;
  min-height: 22rem;
`;

const NewCompany = () => {
  const formik = useFormik({
    initialValues: {
      companyName: '',
      email: '',
    },
    validationSchema: newCompanySchema,
    onSubmit: (values) => {
      // console.log(values); // please remove if unused again
    },
    enableReinitialize: true,
  });

  const { errors, touched } = formik;

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={config?.reCaptchaKey}
      language="en"
      useRecaptchaNet={true}
      useEnterprise={true}
      scriptProps={{
        async: false,
        defer: false,
        appendTo: 'head',
        nonce: undefined,
      }}
      container={{
        element: "new-company-recaptcha",
        parameters: {
          badge: 'inline',
        }
      }}
    >
      <PageContainer className="d-flex align-items-center justify-content-center vh-100">
        <CustomCard>
          <Card>
            <CardContent className="pt-6">
              <form onSubmit={formik.handleSubmit}>
                <div className="mb-4">
                  <Label htmlFor="companyName">Company</Label>
                  <Input
                    id="companyName"
                    name="companyName"
                    type="text"
                    placeholder="Your company name"
                    onChange={formik.handleChange}
                    value={formik?.values?.companyName}
                  />
                  <ErrorWrapper>
                    {errors?.companyName && touched?.companyName ? errors?.companyName : ''}
                  </ErrorWrapper>
                </div>
                <div className="mb-4">
                  <Label htmlFor="email">Email</Label>
                  <Input
                    id="email"
                    name="email"
                    type="email"
                    placeholder="Your email"
                    onChange={formik.handleChange}
                    value={formik?.values?.email}
                  />
                  <ErrorWrapper>
                  {errors?.email && touched?.email ? errors?.email : ''}
                  </ErrorWrapper>
                </div>
                <div id="new-company-recaptcha"></div>
              </form>
            </CardContent>
            <CardFooter>
              <ButtonRightCorner>
                <Button
                  onClick={formik.submitForm}
                >
                  Save
                </Button>
              </ButtonRightCorner>
            </CardFooter>
          </Card>
        </CustomCard>
      </PageContainer>
    </GoogleReCaptchaProvider>
  )
}

export default NewCompany;
